class changeNavCurrent{
	constructor(val) {
		this.margin = $(window).height() / 2,   //ウインドウ上部からどれぐらいの位置で変化させるか
		this._sectionTop = [], //sectionのTop位置格納用
		this._current = -1;   //現在のカレント位置
	}

	changeCurrentClass(curNum){
		if (curNum != this.current) {
		this._current = curNum;
			let curNum2 = curNum + 1;//HTML順序用
			$('.js-fixed_sidemenu li').removeClass('current');
			$('.js-fixed_sidemenu li:nth-child(' + curNum2 +')').addClass('current');
		}
	}

	getPosition(){
		let _this = this;
		$('.js-inner_link').each(function(i) {
			 _this._sectionTop[i] = [];
			 _this._sectionTop[i] = $(this).offset().top;
		});
	}

	exec(){
		let _this = this;
		//各sectionの縦位置を取得
		this.getPosition()
		//init
		this.changeCurrentClass(0);

		//スクロールした時の処理
		$(window).scroll(function(){
			let scrollY = $(window).scrollTop();
			//各セクションの位置とスクロール位置を比較して、条件にあったらchangeNavCurrentを実行
			for (let i = _this._sectionTop.length - 1 ; i >= 0; i--) {
				if (scrollY > _this._sectionTop[i] - _this.margin) {
						_this.changeCurrentClass(i);
					break;
				}
			};
		});
	}
}
module.exports = changeNavCurrent;



// WEBPACK FOOTER //
// ./dev/js/scripts/changeNavCurrent.js